	const swiper = new Swiper(".mySwiper", {
	slidesPerView: 2.5,
	spaceBetween: 10,
	centeredSlides: false,
	loop: true,
	freeMode: true,

    breakpoints: {
      414: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 40,
        centeredSlides: false,
      }
    },
    
    // ナビボタン
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });